var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({attrs:{"id":"app"}},_vm.tooltipEventListeners),[_c('router-view'),_c('GlobalTooltip',{attrs:{"tooltip":_vm.tooltip,"mouseEvent":_vm.tooltipMouseEvent}}),_c('GlobalAlert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }